import React from "react"

import styled from "styled-components"
import NextImg from "@/common/components/NextImg/index"

import { theme } from "./mixin"

import LOGO from "@/common/assets/image/lucky-bag-2023/LOGOWhite.svg"

export default function Footer() {
  return (
    <Wrapper>
      <WrapperL>
        <div></div>
      </WrapperL>
      <WrapperR>
        <div></div>
      </WrapperR>
      <FooterContent>
        <ContentWrapper>
          <LogoWrapper>
            <NextImg src={LOGO} />
          </LogoWrapper>
          <LinkWrapper>
            <a
              href="https://kryptogo.notion.site/KryptoGO-x-91APP-NFT-3ce05f20b3a34a6487c76a5713e8bde3"
              target="_blank"
              rel="noreferrer"
              id="toybox-footerButton1"
            >
              FAQ
            </a>
            <a
              href="https://www.kryptogo.com/tw/company/legal"
              target="_blank"
              rel="noreferrer"
              id="toybox-footerButton2"
            >
              隱私權政策
            </a>
          </LinkWrapper>
          <CopyRightWrapper>2023 © KryptoGO</CopyRightWrapper>
        </ContentWrapper>
        <RulesWrapper>
          <li>
            本活動注意事項載明於本活動網頁中，NFT 一旦被鑄造則無法退還，
            如遇不可抗力之事由或因故導致 NFT
            兌換內容變更，本公司或合作夥伴得自行決定改由其他商品或兌換方式取代，活動參加者不得要求將兌換券內容折換現金或指定更換其他商品。
            本公司保留隨時變更、終止或取消部份或全部本活動之權利及本活動注意事項之最終解釋權，詳細活動辦法以本活動網頁最新公告為準。
          </li>
          <li>
            參加者如因參加本活動或因本活動之兌換品項而遭受任何損失，本公司及合作夥伴均不負任何責任。一旦參加者兌換商品後，若有任何品項遺失、被竊、毀損、瑕疵或其他任何不能正常使用之情形等，本公司不負任何責任，無義務發給任何證明或補償。
          </li>
          <li>
            參加者已充分知悉且同意所提供之個人資料，本公司得於本活動範圍內基於活動稽核、核實兌換人身分及品項派發事宜蒐集、處理、利用其個人資料。參加者依法得向主辦單位請求查詢、複製、補充更正、停止蒐集處理利用或刪除其個人資料。參加者亦得選擇不提供個人資料，但參加者之活動資格將因程序未完成而視為放棄。請參閱本公司
            <a
              target="_blank"
              href="https://www.kryptogo.com/tw/company/legal"
              rel="noreferrer"
            >
              隱私權政策
            </a>
          </li>
          <li>
            根據中華民國《所得稅法》第 14
            條所規定「因競技、競賽及機會中獎之獎金或給與」，若得獎者之身分為我國境內居住人、且獎項價值超過
            2 萬新台幣，則在領獎時必須「預先扣繳」10% 的稅款（KryptoGO
            會提供扣繳憑單）。若得獎的身分為非中華民國境內居住之個人，則無論中獎金額或獎品價值多寡，扣繳義務人都應在給付獎金或獎品時，按中獎價值「預先扣繳」20%
            稅款。
          </li>
          {/* <li>
            本公司保留隨時變更、終止或取消部份或全部本活動之權利及本活動注意事項之最終解釋權，詳細活動辦法以本活動網頁最新公告為準。
          </li> */}
        </RulesWrapper>
      </FooterContent>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  background-color: ${theme.secondary};
  padding: 60px;
  position: relative;
`

const WrapperL = styled.div`
  position: absolute;
  top: -73px;
  left: 0px;
  > div {
    position: relative;
    overflow: hidden;
    width: 73px;
    height: 73px;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 73px;
      width: 146px;
      height: 146px;
      transform: translate(-50%, -50%);
      /* background-color: #fff; */
      border-radius: 50%;
      border: 100px solid ${theme.secondary};
      box-sizing: content-box;
    }
  }
  @media (${theme.md}) {
    top: -40px;
    > div {
      width: 40px;
      height: 40px;
      &:before {
        left: 40px;
        width: 80px;
        height: 80px;
        transform: translate(-50%, -50%);
        /* background-color: #fff; */
        border-radius: 50%;
        border: 100px solid ${theme.secondary};
        box-sizing: content-box;
      }
    }
  }
`
const WrapperR = styled.div`
  position: absolute;
  top: -73px;
  right: 0;
  > div {
    position: relative;
    overflow: hidden;
    width: 73px;
    height: 73px;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0px;
      width: 146px;
      height: 146px;
      transform: translate(-50%, -50%);
      /* background-color: #fff; */
      border-radius: 50%;
      border: 100px solid ${theme.secondary};
      box-sizing: content-box;
    }
  }
  @media (${theme.md}) {
    top: -40px;
    > div {
      width: 40px;
      height: 40px;
      &:before {
        right: 40px;
        width: 80px;
        height: 80px;
        transform: translate(-50%, -50%);
        /* background-color: #fff; */
        border-radius: 50%;
        border: 100px solid ${theme.secondary};
        box-sizing: content-box;
      }
    }
  }
`
const FooterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  gap: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.8;
  opacity: 1;
  color: white;
  li {
    flex: 1;
    opacity: 0.8;
  }
  a {
    border-bottom: 1px solid;
    color: white;
  }

  @media (${theme.lg}) {
    grid-template-columns: repeat(1, 1fr);
  }
`
const ContentWrapper = styled.div`
  display: flex;
  gap: 30px;
  flex-direction: column;
  justify-content: start;
  width: 250px;
  @media (${theme.lg}) {
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`

const LogoWrapper = styled.div`
  width: 200px;
`
const LinkWrapper = styled.div`
  display: flex;
  gap: 12px;
  font-size: 16px;
`
const CopyRightWrapper = styled.div``
const RulesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  @media (${theme.xl}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (${theme.md}) {
    grid-template-columns: repeat(1, 1fr);
  }
`
const RulesWrapperF = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  li {
    flex: 1 1 calc(25% - 24px);
  }
  @media (${theme.xl}) {
    li {
      flex: 1 1 calc(50% - 24px);
    }
  }
  @media (${theme.md}) {
    li {
      flex: 1 1 100%;
    }
  }
`
